import APIS from '../../constant/EndPoint';
import NACell from '../Reusable/DataTable/NACell';
import TableActionButton from '../Reusable/TableActionButton';
import DataTable from '../Reusable/DataTable/UserDataTable';

const RoleList = () => {
  const defaultColumns: any = [
    {
      header: "S.N",
      accessorKey: ".",
      cell: ({ row }: any) => <>{row?.index + 1}</>,
    },
    {
      header: "Name",
      accessorKey: "group_name",
      cell: NACell,
    },
    {
      header: "Allow Permission",
      accessorKey: "custom_permissions",
      cell: ({ row, getValue }: any) => (
        <>
          {getValue() ? getValue()?.length : 0}
        </>
      ),
    },
    {
      header: "Assign Member",
      accessorKey: "primary_email",
      cell: NACell,
    },
    {
      header: "Action",
      accessorKey: "pk",
      cell: ({ row, getValue }: any) => (
        <>
          <TableActionButton editPath={`edit/${getValue()}`} />
        </>
      ),
    }
  ];

  return (
    <DataTable
      url={APIS.GROUP}
      queryKey={"roles"}
      columns={defaultColumns}
      addNewPagePath={"/role-create"}
      tableName={"Role"}
    />
  )
}

export default RoleList